<template>
  <div id="index">
    <!-- 头部 -->
    <!-- <div id="preloader"></div> -->
    <header class="header-one">
      <!-- header-area start -->
      <div
        id="sticker"
        class="header-area hidden-xs"
        :class="{ stick: nScrollTop > 100 }"
      >
        <div class="container">
          <div class="row">
            <!-- logo start -->
            <div class="col-md-3 col-sm-3">
              <div class="logo">
                <!-- Brand -->
                <router-link
                  class="navbar-brand page-scroll sticky-logo"
                  to="/Home"
                >
                  <img src="../assets/new/img/logo/logo2.png" alt />
                </router-link>
              </div>
            </div>
            <!-- logo end -->
            <div class="col-md-9 col-sm-9">
              <!-- mainmenu start -->
              <nav class="navbar navbar-default">
                <div class="collapse navbar-collapse" id="navbar-example">
                  <div class="main-menu">
                    <ul class="nav navbar-nav navbar-right pc1111">
                      <li>
                        <router-link to="/Home">首页</router-link>
                      </li>
                      <li>
                        <router-link to="/DownLoad">下载</router-link>
                      </li>
                      <li>
                        <router-link to="/faq">常见问题</router-link>
                      </li>
                      <li>
                        <a class="pagess">关于我们</a>
                        <ul class="sub-menu">
                          <li>
                            <router-link to="/aboutxy_details"
                              >关于星瀛科技</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/aboutus_details"
                              >关于海星云</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/Contact">商务合作</router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- pc端 -->
                      <dl class="u-reaged">
                        <dt>
                          <a class="o1" @click="Signln">
                            <i class="iconfont">&#xe687;</i>
                            <span>&nbsp;&nbsp;{{ qiehuan }}</span>
                          </a>
                          <el-popover
                            v-if="tokenen && !mobile_flag"
                            placement="bottom"
                            width="250"
                            trigger="click"
                            popper-class="popper-class-override"
                          >
                            <!-- <div id="qrcode" class="payCode"></div> -->
                            <!-- <p>请使用手机扫描二维码完成支付</p> -->
                            <div class="qrcode-box">
                              <img
                                class="recharge-qrcode-img"
                                v-show="rechargeQRCodeUrl"
                                :src="rechargeQRCodeUrl"
                                alt="充值二维码"
                              />
                            </div>
                            <div class="recharge-desc-box">
                              <div class>请使用手机扫描二维码</div>
                              <div>打开充值</div>
                            </div>
                            <el-button
                              class="o2"
                              slot="reference"
                              style="border-radius: 26px"
                              @click="Rechargeing"
                            >
                              <i class="iconfont">&#xe67b;</i>&nbsp;&nbsp;充值
                            </el-button>
                          </el-popover>
                          <a v-else class="o2" @click="Rechargeing">
                            <i class="iconfont">&#xe67b;</i>
                            <span>&nbsp;&nbsp;充值</span>
                          </a>
                          <a class="o3" @click="Register" v-if="tokenen">
                            <i class="iconfont">&#xe6e9;</i>
                            <span>&nbsp;&nbsp;{{ zczx }}</span>
                          </a>
                        </dt>
                      </dl>
                    </ul>
                  </div>
                </div>
              </nav>
              <!-- mainmenu end -->
            </div>
          </div>
        </div>
      </div>
      <!-- header-area end -->
      <!-- 手机 mobile-menu-area start -->
      <div class="mobile-menu-area hidden-lg hidden-md hidden-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="mobile-menu">
                <div class="logo">
                  <router-link
                    class="navbar-brand page-scroll sticky-logo"
                    to="/Home"
                  >
                    <img src="../assets/new/img/logo/logo2.png" alt />
                  </router-link>
                </div>
                <nav id="dropdown" class="sj22222">
                  <ul>
                    <li>
                      <router-link to="/Home">首页</router-link>
                    </li>
                    <li>
                      <router-link to="/DownLoad">下载</router-link>
                    </li>
                    <li>
                      <router-link to="/faq">常见问题</router-link>
                    </li>
                    <li>
                      <a class="pagess">关于我们</a>
                      <ul class="sub-menu">
                        <li>
                          <router-link to="/aboutxy_details"
                            >关于星瀛科技</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/aboutus_details"
                            >关于海星云</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/Contact">商务合作</router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- 手机端 -->

                    <dl class="u-reaged" style="font-size: 70%">
                      <dt>
                        <a class="o1" @click="Signln" id="Signln11">
                          <span>{{ qiehuan }}</span>
                        </a>

                        <a class="o2" @click="Rechargeing" id="Signln22">
                          <span>充值</span>
                        </a>
                        <a
                          class="o3"
                          @click="Register"
                          v-if="tokenen"
                          id="Signln33"
                        >
                          <span>{{ zczx }}</span>
                        </a>
                      </dt>
                    </dl>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile-menu-area end -->
    </header>

    <div class="content">
      <router-view></router-view>
    </div>
    <!-- Start Footer bottom Area -->

    <newLogin ref="Login1"></newLogin>
    <!-- <LoginSucce ref="LoginSucce"></LoginSucce> -->
  </div>
</template>

<script>
import newLogin from '@/base/newLogin.vue'
import LoginSucce from '@/base/LoginSucce.vue'
import adaption from '@/mixi/adaption'
// import QRCode from 'qrcodejs2'
import QRCode from 'qrcode'

export default {
  mixins: [adaption],
  // 接收注入的数据
  inject: [
    'reload'
  ],
  components: {
    newLogin,
    LoginSucce
  },
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },

  data () {
    return {
      nScrollTop: 0,
      isActive: false, // 往上
      tokenen: '',
      // 切换登录 和 个人中心
      qiehuan: '注册/登录',
      // 切换注册 和 注销
      zczx: '注册/登录',
      // 二维码图片src
      rechargeQRCodeUrl: ''
    }
  },
  methods: {
    showRouter () {
      // 调用reload方法，刷新整个页面
      this.reload()
    },
    windowScroll () {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      this.nScrollTop = scrollTop
    },

    // 登录
    Signln () {
      this.$nextTick(() => {
        this.$refs.Login1.FatherIndex()
        this.$refs.Login1.switchLogin(4)
        this.$refs.Login1.qrShow = true
      })
      if (this.qiehuan == '个人中心') {
        this.$router.push('./Center')
      } else {
        this.$refs.Login1.bLogin1 = true
        this.$refs.Login1.nwxLogin = 1
      }
      this.$refs.Login1.longinMS()
    },
    // 充值
    Rechargeing () {
      if (this.tokenen) {
        let userName = window.localStorage.getItem('user_name')
        let vip_level = window.localStorage.getItem('vip_level')
        // 获取个人信息
        this.http.getUserInfo({token: this.tokenen, username: 'username'}).then(res => {
          let result = {}
          if (res.status !== 200) {
            this.$message.info('获取个人信息请求失败')
            return
          }
          result = res.data
          if (result.code !== 200) {
            this.$message.info(result.$message)
            return
          }
          let userInfo = result.data
          let phone = userInfo.phone
          let vipLevel = userInfo.vip_level
          let pay = `https://www.haixingcloud.com:8002/#/pay?userName=${phone}&t=${this.tokenen}&level=${vipLevel}`
          if (this.mobile_flag) {
            // 手机充值
            window.location.href = pay
          } else {
            // 弹出充值二维码
            if (this.rechargeQRCodeUrl) return
            this.generateQR(pay)
            // window.location.href = `${window.location.protocol}//${window.location.host}/#/Rechargeing`
          }
        })
      } else {
        window.location.href = `${window.location.protocol}//${window.location.host}/#/Home?flag=1`
        this.$refs.Login1.bLogin1 = true
        this.$refs.Login1.nwxLogin = 1
      }
    },
    // 生成二维码图片
    generateQR (pay) {
      QRCode.toDataURL(pay).then(res => {
        this.rechargeQRCodeUrl = res
      }).catch(error => {
        console.warn(error)
        this.$message.info('生成二维码异常')
      })
    },
    // 注册
    Register () {
      if (this.tokenen != '') {
        this.$cookieStore.delCookie('user_sess')
        window.localStorage.removeItem('state')
        window.location.href = `${window.location.protocol}//${window.location.host}/#/Home`
        window.location.reload()
      } else {
        this.$refs.Login1.bLogin1 = true
        this.$refs.Login1.nwxLogin = 1
      }
    }
  },
  created () {
    // 返回顶部
    var that = this
    window.οnscrοll = function () {
      if (document.documentElement.scrollTop > 60) {
        that.isActive = true
      } else {
        that.isActive = false
      }
    }
  },
  mounted () {
    this.$on('global:denglu', () => {
      this.Signln()
    })
    window.addEventListener('scroll', this.windowScroll)
    this.tokenen = this.$cookieStore.getCookie('user_sess')
    if (this.tokenen != '') {
      this.qiehuan = '个人中心'
      this.zczx = '注销'
    } else if (this.tokenen == '') {
      this.qiehuan = '注册/登录'
      this.zczx = '注册/登录'
    }

    this.$nextTick(() => {
      var mean_menu = $('nav#dropdown')
      mean_menu.meanmenu()

      $('#Signln11').click(() => {
        this.Signln()
      })
      $('#Signln22').click(() => {
        this.Rechargeing()
      })
      $('#Signln33').click(() => {
        this.Register()
      })
    })
  }
}
</script>

<style>
.popper-class-override {
  padding: 20px 0 0 0 !important;
  border: none !important;
  outline: none !important;
  background-color: #25304c !important;
  border-radius: 8px !important;
  /* background: transparent !important; */
  /* min-width: 115px !important; */
}
.popper-class-override .qrcode-box {
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin: 20px auto;
}
.popper-class-override .qrcode-box .recharge-qrcode-img {
  width: 100%;
  height: 100%;
}
.popper-class-override .popper__arrow {
  border-bottom-color: #25304c !important;
}
.popper-class-override .popper__arrow::after {
  border-bottom-color: #25304c !important;
}
.popper-class-override .recharge-desc-box {
  margin-bottom: 30px !important;
  color: #fff !important;
}
.el-popover {
  text-align: center;
}
.payCode img {
  display: block;
  width: 180px;
  height: 180px;
  margin: 20px auto;
  background-color: #fff;
  padding: 6px;
}
.payCode p {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Tou.vue